import MoneyDisplay from 'components/util/MoneyDisplay';
import { Fragment } from 'react';
import { PartyAssetCurrencyTotal } from './types';

interface Props {
    totals: PartyAssetCurrencyTotal[];
    /** Read as zero in this currency when nothing matches, as the contact card's other money figures read. */
    emptyCurrency?: string;
}

/** One sum per currency, never converted or added across currencies: `10 000.00 EUR · 500.00 USD`. */
export function AssetTotals({ totals, emptyCurrency }: Props) {
    const shown = totals.length || !emptyCurrency ? totals : [{ currency: emptyCurrency, amount: 0 }];
    return (
        <span>
            {shown.map(({ currency, amount }, index) => (
                <Fragment key={currency}>
                    {index > 0 ? ' · ' : null}
                    <MoneyDisplay amount={amount} currency={currency} />
                </Fragment>
            ))}
        </span>
    );
}
